import { useCourseKit } from "../provider.tsx";
import { siteCopy, type SiteCopy } from "./site.ts";

/** Learner-site copy in the visitor's current locale (layout, pages, player, primitives). */
export const useSiteCopy = (): SiteCopy => siteCopy[useCourseKit().locale];
